const l = {
  name: "CheckmarkCircleSmallFill",
  dimensions: { width: 24, height: 24 },
  content: `
    <g fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z" fill="currentColor"/>
    </g>
  `
};
export {
  l as CheckmarkCircleSmallFill
};
